var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('div',{staticClass:"light-background"},[(_vm.hasLikeDownload)?_c('CommonOverlay',{attrs:{"data":_vm.data}},[_c('SvgMerchEffect',{attrs:{"data":_vm.data}})],1):_c('div',{staticClass:"overlay",style:(_vm.overlayStyles)},[_c('SvgMerchEffect',{attrs:{"data":_vm.data}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }